import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useGameStore } from "~/state/game-store";
import { Button } from "~/ui/system/button";
import { Dialog } from "~/ui/system/dialog";
import { MetalWrapper } from "~/ui/system/metal-wrapper";

export const PauseMenu = memo(function PauseMenu() {
  const navigate = useNavigate();
  const setOpenMenu = useGameStore((s) => s.setOpenMenu);
  const saveGame = useGameStore((s) => s.saveGame);

  const handleBackToTitle = async () => {
    // Save game before exiting
    await saveGame();
    useGameStore.setState({ gameStarted: false });
    await navigate("/");
  };

  const handleResume = () => {
    setOpenMenu(null);
  };

  const handleSettings = () => {
    setOpenMenu("settings");
  };

  return (
    <Dialog onClose={handleResume}>
      <MetalWrapper className="w-80">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6 font-mono text-white">
            Game Paused
          </h2>
          <div className="space-y-3">
            <Button onClick={handleResume} className="w-full">
              Resume Game
            </Button>
            <Button
              variant="secondary"
              onClick={handleSettings}
              className="w-full"
            >
              Settings
            </Button>
            <Button
              variant="secondary"
              onClick={handleBackToTitle}
              className="w-full"
            >
              Save and Exit
            </Button>
          </div>
          <div className="mt-4 text-sm text-gray-400 font-mono">
            Press ESC to resume
          </div>
        </div>
      </MetalWrapper>
    </Dialog>
  );
});
